<template>
  <div ref="outer" class="outer">
    <slot name='item'></slot>
  </div>
</template>

<style scoped>
  .outer {
    position: relative;
  }
</style>

<script>
import { rafListener } from '../../lib/global-listeners/index.js'
import { getScrollPercentage } from './helpers/calculations.js'

export default {
  props: {
    noNormalize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      percent: 0,
      margin: 0.1,
      top: null,
      center: null,
      bottom: null,
      isInViewport: false
    }
  },
  mounted() {
    this.onupdate = () => this.update()
    this.removeListener = rafListener.add(this.onupdate)
  },
  beforeDestroy() {
    this.removeListener()
  },
  methods: {
    update() {
      const { percent, isInViewport, top, bottom, center } = getScrollPercentage(
        this.$el,
        this.margin
          ? { margin: this.margin, noNormalize: this.noNormalize }
          : { noNormalize: this.noNormalize }
      )
      this.center = center
      this.percent = percent
      this.isInViewport = isInViewport
      this.top = top
      this.bottom = bottom
    }
  },
  watch: {
    isInViewport(isInViewport) {
      this.$emit('inviewport-change', { isInViewport })
    },
    percent(percent) {
      this.$emit('percent-change', { percent })
    },
    top(top) {
      this.$emit('top-change', { top })
    },
    center(center) {
      this.$emit('center-change', { center })
    },
    bottom(bottom) {
      this.$emit('bottom-change', { bottom })
    }
  }
}
</script>
